export class DeviceUpdRequest {
    public user: string;
    public id_device: any;
    public platform: string;
    public app_name: string;

    constructor(user: string, id_device: string, platform: string, app_name: string){
        this.user = user;
        this.id_device = id_device;
        this.platform = platform;
        this.app_name = app_name
    }
}